module.exports = __webpack_public_path__ + "img/voucher.6431d3f7.svg";